import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  createTicket,
  createTicketSuccess,
  getMessageTemplates,
  getMessageTemplatesForTicket,
  getMessageTemplatesForTicketSuccess,
  loadChatUsers,
  loadChatUsersSuccess,
  getHistoryTickets,
  getHistoryTicketsSuccess
} from './actions';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { MessageTemplatesService } from '../../../services/message-templates.service';
import { httpError } from '../../../shared/store/actions';
import { Injectable, inject } from '@angular/core';
import { ChatUserService } from '../../../services/chat-user.service';
import { TicketsService } from '../../../services/tickets.service';

@Injectable()
export class TicketsEffects {
  private actions$ = inject(Actions);
  private messageTemplatesService = inject(MessageTemplatesService);
  private chatUsersService = inject(ChatUserService);
  private ticketsService = inject(TicketsService);

  getMessageTemplatesForTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getMessageTemplatesForTicket),
      exhaustMap((action) =>
        this.messageTemplatesService
          .getTemplatesForTicket(action.ticketId)
          .pipe(
            map((messageTemplates) =>
              getMessageTemplatesForTicketSuccess({ messageTemplates })
            ),
            catchError((error) => of(httpError({ error })))
          )
      )
    )
  );

  getChatUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadChatUsers),
      exhaustMap((action) =>
        this.chatUsersService.getChatUsers(action.filter).pipe(
          map((users) => loadChatUsersSuccess({ users })),
          catchError((error) => of(httpError({ error })))
        )
      )
    )
  );

  getMessageTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getMessageTemplates),
      exhaustMap((action) =>
        this.messageTemplatesService.getTemplates(action.connectionId).pipe(
          map((messageTemplates) =>
            getMessageTemplatesForTicketSuccess({ messageTemplates })
          ),
          catchError((error) => of(httpError({ error })))
        )
      )
    )
  );

  creatTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createTicket),
      exhaustMap((action) =>
        this.ticketsService.createTicket(action.data).pipe(
          map((result) => createTicketSuccess({ result })),
          catchError((error) => of(httpError({ error })))
        )
      )
    )
  );

  getHistoryTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getHistoryTickets),
      exhaustMap((action) =>
        this.ticketsService
          .getHistoryTickets(action.params)
          .pipe(
            map((tickets) =>
              getHistoryTicketsSuccess({ tickets })
            ),
            catchError((error) => of(httpError({ error })))
          )
      )
    )
  )
}
